
define('ldsh!modules/stats/templates/navigation', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="pt32 mb32">\n  <div class="ed-title-bar flex align-center gap-8">\n    <h2 class="ed-h-beta js-name-display">\n      <a href="javascript:void(0)" class="js-edit-name">\n        <span data-i18n="common.stats"></span>\n      </a>\n    </h2>\n  </div>\n\n  <div class="wrapper mt16">\n    <div class="date-filter-trigger standalone-filter flex align-center gap-8">\n      <div class="flex align-center gap-16 flex-grow-1">\n        <div class="js-monthpicker flex-grow-1"></div>\n      </div>\n    </div>\n  </div>\n\n</div>';

}
return __p
};});

